<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <g clip-path="url(#clip0_885_41748)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.90597 9.27576L4.90608 9.27558L4.90608 9.27557C7.80242 4.15057 9.25061 1.58805 11.2379 0.928419C12.3311 0.565527 13.5088 0.565527 14.602 0.928419C16.5892 1.58803 18.0373 4.15042 20.9335 9.27513L20.9339 9.27576C23.8303 14.4008 25.2785 16.9634 24.8441 19.0514C24.605 20.2002 24.0162 21.242 23.1619 22.0279C21.6091 23.4563 18.7128 23.4563 12.9199 23.4563C7.1271 23.4563 4.23069 23.4563 2.67788 22.0279C1.82362 21.242 1.23479 20.2002 0.99579 19.0514C0.561355 16.9634 2.00956 14.4008 4.90597 9.27576ZM11.4102 17.8555C11.4102 17.027 12.0817 16.3555 12.9102 16.3555H12.921C13.7494 16.3555 14.421 17.027 14.421 17.8555C14.421 18.6839 13.7494 19.3555 12.921 19.3555H12.9102C12.0817 19.3555 11.4102 18.6839 11.4102 17.8555ZM14.4199 8.45703C14.4199 7.6286 13.7483 6.95703 12.9199 6.95703C12.0915 6.95703 11.4199 7.6286 11.4199 8.45703V13.2571C11.4199 14.0855 12.0915 14.7571 12.9199 14.7571C13.7483 14.7571 14.4199 14.0855 14.4199 13.2571V8.45703Z"
        fill="#E8405F"
      />
    </g>
    <defs>
      <clipPath id="clip0_885_41748">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.919922 0.0566406)"
        />
      </clipPath>
    </defs>
  </svg>
</template>